import { render, staticRenderFns } from "./NotificationPermission.vue?vue&type=template&id=eb61c80c&scoped=true"
import script from "./NotificationPermission.vue?vue&type=script&lang=js"
export * from "./NotificationPermission.vue?vue&type=script&lang=js"
import style0 from "./NotificationPermission.vue?vue&type=style&index=0&id=eb61c80c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "eb61c80c",
  null
  
)

export default component.exports